
<span class="search-input">
  <mat-form-field
    class="small-form-field"
    [floatLabel]="(autoCompleteInput || isAddressFocused) ? 'always' : 'auto'">
    <mat-label>Property Address</mat-label>
    <input
      matInput
      [(ngModel)]="autoCompleteInput"
      #searchField
    />
  </mat-form-field>
</span>